import React, { useEffect, useContext } from "react";
import { StoreContext } from "../../../../../Store/Provider";
import MilestoneMapComponents from "./MilestoneMapComponents";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import moment from "moment";
import { routeConstant } from "../../../../../Route/utils/routeConstant";
import { useNavigate, useLocation } from "react-router-dom";

const FlightData = (props) => {
  const context = useContext(StoreContext);
  const history = useNavigate();
  useEffect(() => {
    console.log(
      props.data.ShipmentOriginETD,
      props.data.ShipmentDestinationETA
    );
  }, []);

  return (
    <div className="flight_details">
      <h5>
        <span onClick={() => history(routeConstant.ShipmentsListing)}>
          <ArrowBackIosIcon />
        </span>
        {props.data.ShipmentId}
      </h5>
      <div className="flightDetailData">
        <p>Flight No.</p>
        <p>{props?.data?.Voyage ? props.data.Voyage : "N/A"}</p>
      </div>
      <div className="flightDetailData">
        <p>ETA</p>
        <p>{props.data?.ShipmentDestinationETA.split(" ")[0]}</p>
      </div>
      <div className="flightDetailData">
        <p>ETD</p>
        <p>{props.data.ShipmentOriginETD.split(" ")[0]}</p>
      </div>
    </div>
  );
};

export default FlightData;
